export default {
  init() {
    // JavaScript to be fired on the home page
    $('nav li a').navScroller();
		//section divider icon click gently scrolls to reveal the section
		$(".sectiondivider").on('click', function(event) {
			$('html,body').animate({scrollTop: $(event.target.parentNode).offset().top - 50}, 400, "linear");
		});
		
		//Accordeon click event
    $('.accordeon').mouseleave(function(){
        $(this).find('li').removeClass('open-item').removeClass('closed-item');

    });
    $('.accordeon li').click(function(e){
        e.preventDefault();
        var $this = $(this);
        $this.addClass('open-item');
        $this.siblings().removeClass('open-item').addClass('closed-item');    
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js